export const LocalBusiness = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Agile Infoways LLC",
  image: "https://www.agileinfoways.com/images/agile-logo-black.svg",
  "@id": "",
  url: "https://www.agileinfoways.com/",
  telephone: "+1-470-772-5053",
  priceRange: "$25-$49",
  address: {
    "@type": "PostalAddress",
    streetAddress: "4905 NW 105th Dr",
    addressLocality: "Coral Springs",
    addressRegion: "FL",
    postalCode: "33076",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 26.2916885,
    longitude: -80.2666733,
  },
  //  remove Schema as per told by SEO team
  // "aggregateRating": {
  //     "@type": "AggregateRating",
  //     "ratingValue": "5.0",
  //     "bestRating": "5",
  //     "ratingCount": "500"
  // }
}
